import { API } from "../../../utils";

export const getSupersetGuestToken = async (payload) => {
  const res = await API.post("superset/guest-token", payload);
  return res.data.data;
};
